module.exports = __webpack_public_path__ + "static/media/zm.2a8b2cd7.webp";